
import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator';

@Component({})
export default class IdField extends Vue {
  val = '';

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Model('change', {
    type: Number,
  })
  value!: number;

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = `${this.value}`;
    } else {
      this.val = '';
    }
  }

  mounted() {
    this.watchValue();
  }
}
